import { useQuery } from '@apollo/client';
import { Col, Row } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';

import { FormItemInputText } from '../../../components/forms/basicFormElements';
import { JobLocationSection } from '../newShipment/newShipmentElements';
import AirlineAutoComplete from './components/AirlineAutoComplete';
import AirportAutoComplete from './components/AirportAutoComplete';
import { FormItemDateTimePicker } from '../../../components/forms/dateElements';
import {
  AIRLINES_QUERY,
  AIRPORTS_QUERY,
} from '../../../app/graphql/jobQueries';
import FormItemAddFlight from './components/AddFlightButton';

export default function AirRetrievalManualEntry({ className }) {
  const { formatMessage } = useIntl();
  const { data, loading } = useQuery(AIRLINES_QUERY);
  const { data: airports, loading: isAirportsLoading } =
    useQuery(AIRPORTS_QUERY);

  return (
    <div className={className}>
      <Row justify="end">
        <FormItemAddFlight disabled={isAirportsLoading || loading} />
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.departureAirport"
            requiredInTitle
          >
            <AirportAutoComplete
              name="manualDepartureAirport"
              airports={airports?.getAirports || []}
              rules={[{ required: true }]}
              isLoading={isAirportsLoading}
              isArrival={false}
            />
          </JobLocationSection>
        </Col>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.departure"
            requiredInTitle
          >
            <FormItemDateTimePicker
              name="manualDeparture"
              rules={[{ required: true }]}
              floatingLabel={false}
              expandSize
            />
          </JobLocationSection>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.arrivalAirport"
            requiredInTitle
          >
            <AirportAutoComplete
              name="manualArrivalAirport"
              airports={airports?.getAirports || []}
              rules={[{ required: true }]}
              isLoading={isAirportsLoading}
            />
          </JobLocationSection>
        </Col>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.arrival"
            requiredInTitle
          >
            <FormItemDateTimePicker
              name="manualArrival"
              rules={[{ required: true }]}
              floatingLabel={false}
              expandSize
            />
          </JobLocationSection>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.airline"
            requiredInTitle
          >
            <AirlineAutoComplete
              name="manualAirline"
              airlines={data?.getAirlines || []}
              rules={[{ required: true }]}
              isLoading={loading}
            />
          </JobLocationSection>
        </Col>
        <Col span={12}>
          <JobLocationSection
            titleId="book.newAirRetrieval.flightNumber"
            requiredInTitle
          >
            <FormItemInputText
              name="manualFlightNumber"
              placeholder={formatMessage({
                id: 'book.newAirRetrieval.flightNumber.placeholder',
              })}
              floatingLabel={false}
              rules={[{ required: true }]}
            />
          </JobLocationSection>
        </Col>
      </Row>
    </div>
  );
}
